module.exports = function getResource(label, vars = []) {
    let resources = {
        kilometer: 'kilomètre',
        mile: 'mille',
        away: 'absent',
        closed: 'Fermé',
        openUntil: 'Ouvert jusqu’à ',
        getDirections: 'Obtenir l’itinéraire'
    };

    return resources[label];
};
